// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.89.2',
  revision: '52e4fe522',
  branch: 'master',
  date: 'Thu, 13 Aug 2026 13:52:01 GMT'
};